// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__RbAKA","container":"Hero_container__caVmh","title":"Hero_title__Ejz3K"};